<db-dialog-wrapper [dialog]="this" [fullScreen]="true" [closeButtonTop]="'24px'" [closeButtonRight]="'30px'">
  <div class="db-available-themes">
    <div class="db-available-themes__title">{{'text_addTheme' | dbText}}</div>

    <div class="db-available-themes__body">
      <div class="db-available-themes__filters-bar db-filters-bar">
        <div></div>
        <div class="db-available-themes__search-wrap" *ngIf="activeTab !== 'upload'">
          <db-fc-search-input [formControl]="searchTerm" placeholderTitle="{{'text_searchThemes' | dbText}}" placeholder="{{'text_searchEllipsis' | dbText}}"></db-fc-search-input>
        </div>
      </div>

      <db-tabs class="db-available-themes__tabs" [activeTabId]="activeTab" (onActiveTabChange)="setActiveTab($event.tabId)">
        <db-tab-head tabId="upload"><span>{{'text_upload-plugins' | dbText}}</span></db-tab-head>
        <db-tab-head tabId="wordpress"><span>{{'text_wordpress-plugins' | dbText}}</span></db-tab-head>

        <db-tab-content>
          <div class="db-available-themes__panel db-panel db-panel_flex">
            <div dbCustomScrollbar class="db-panel__body" *ngIf="activeTab !== 'upload'">
              <div class="db-available-themes__panel-content">
                <div>
                  <div *ngIf="filteredThemes && filteredThemes.length && !loading">
                    <div *ngFor="let availableTheme of filteredThemes">
                      <db-available-theme class="{{activeTab}}"
                                          [website]="website"
                                          [product]="availableTheme"
                                          [userPermissions]="userPermissions"
                                          [userSubscriptions]="userSubscriptions"
                                          [currentSubscription]="currentSubscription"
                                          [activeTab]="activeTab"
                      ></db-available-theme>
                    </div>
                  </div>

                  <db-empty-search class="db-available-themes__empty-search" *ngIf="filteredThemes && !filteredThemes.length"></db-empty-search>
                </div>

              </div>
            </div>

            <div class="db-available-themes__panel-content db-available-themes__upload-tab" *ngIf="activeTab === 'upload'">
              <file-drop class="db-available-themes__upload" customstyle="db-available-themes__upload-drop-zone" (onFileDrop)="onThemeArchiveDrop($event)" *ngIf="activeTab === 'upload'">
                <div class="db-available-themes__upload-icon"></div>

                <ng-container *ngIf="!uploadActivity">
                  <div class="db-available-themes__upload-title">{{'text_uploadFile' | dbText}}</div>
                  <div class="db-available-themes__upload-message">{{'text_uploadThemeMessage' | dbText}}</div>
                  <div class="db-available-themes__upload-button">
                    <label><a class="db-button db-button_info"><span>{{'text_uploadChooseFile' | dbText}}</span></a><input type="file" class="sl-upload-file" (change)="onThemeArchiveSelect($event)"></label>
                  </div>
                </ng-container>

                <ng-container *ngIf="uploadActivity && ![ActivityStatus.DONE, ActivityStatus.FAILED].includes(uploadActivity.status)">
                  <div class="db-available-themes__upload-title">{{'text_installing' | dbText}}</div>
                  <div class="db-available-themes__upload-message">{{'text_uploadThemeInstallingMessage' | dbText}}</div>
                  <div class="db-available-themes__upload-progress db-progress-bar"><db-progress-bar size="sm" [progressPercent]="uploadActivity?.progress"></db-progress-bar></div>
                </ng-container>

                <ng-container *ngIf="uploadActivity?.status === ActivityStatus.DONE">
                  <div class="db-available-themes__upload-title">{{'text_optimizerOptimizeSuccess' | dbText}}</div>
                  <div class="db-available-themes__upload-message">{{'text_uploadThemeSuccessMessage' | dbText}}</div>
                  <div class="db-available-themes__upload-progress db-progress-bar"><db-progress-bar size="sm" state="success" [progressPercent]="100"></db-progress-bar></div>
                </ng-container>

                <ng-container *ngIf="uploadActivity?.status === ActivityStatus.FAILED">
                  <div class="db-available-themes__upload-title">{{'text_uploadFail' | dbText}}</div>
                  <div class="db-available-themes__upload-message">{{'text_uploadThemeFailMessage' | dbText}}</div>
                  <div class="db-available-themes__upload-progress"><db-progress-bar size="sm" state="danger" [progressPercent]="100"></db-progress-bar></div>
                  <div class="db-available-themes__upload-button">
                    <label><a class="db-button db-button_default" (click)="resetUploadState()"><span>{{'text_uploadTryAgain' | dbText}}</span></a></label>
                  </div>
                </ng-container>
              </file-drop>
            </div>

            <db-loading-screen *ngIf="loading"></db-loading-screen>
          </div>
        </db-tab-content>
      </db-tabs>
    </div>
  </div>
</db-dialog-wrapper>
